import { render, staticRenderFns } from "./CategoryCustomFields.vue?vue&type=template&id=5a97bdce"
import script from "./CategoryCustomFields.vue?vue&type=script&lang=ts"
export * from "./CategoryCustomFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports